import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import './styles/variables.css';
import './styles/layout.css';
import './styles/utilities.css';
import './styles/animations.css';
import './App.css';

import App from './App';
import { LanguageProvider } from './i18n/LanguageProvider';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </BrowserRouter>
);
